<template lang="html">
  <div>
    <template v-if="loading">
      <pl-spinner
        style="margin-left: auto; margin-right: auto; margin-top: 200px"
        class="x2 mt10"
      />
    </template>
    <template v-else>
      <div class="row col-xs no-padding no-margin justify-end">
        <pl-button
          class="remove-selected-users pl-ruby"
          style="display: inline-block"
          @click.native="removeCourses"
          :disabled="!selectedCourses.length"
        >
          Remove Selected Courses
        </pl-button>
      </div>
      <span v-if="coursesList.length"
        >{{ schoolCoursesCount }} / {{ totalSchoolCourses }} Courses</span
      >
      <table v-if="coursesList" class="users-table mv3 w-100">
        <thead>
          <tr class="row">
            <td class="col-xs-1 b">
              <pl-checkbox
                v-model="allSelected"
                @change="selectAll"
                class="col-xs-1"
              />
            </td>
            <td class="col-xs-3 b">Course Name</td>
            <td class="col-xs-3 b">Teacher</td>
            <!-- <td class="col-xs-2 b">School</td> -->
            <!-- (ignore for now; will be done on #259) -->
            <td class="col-xs-2 b">RTs</td>
            <td class="col-xs-2 b">Status</td>
          </tr>
        </thead>
        <tbody
          v-if="coursesList.length > 0 && !loadingTable"
          id="admin-portal-course-table"
          @scroll="$emit('scroll-on-table')"
        >
          <tr class="row" v-for="(course, index) in coursesList" :key="index">
            <td class="col-xs-1">
              <pl-checkbox
                :id="course.id"
                v-model="course.selected"
                @change="checkAllSelected"
                class="col-xs-1"
              />
            </td>
            <td class="col-xs-3 flex">
              <span
                class="name-cell cursor-pointer truncate"
                @click="openCourseDetails(course)"
              >
                {{ course.title }}
              </span>
            </td>
            <td class="col-xs-3 email-cell">
              <span v-if="course.teacher_email" class="truncate">
                {{ course.teacher_email }}
              </span>
              <span v-else class="ruby b"> No Teacher(s) </span>
            </td>

            <td class="col-xs-2">{{ course.number_rts }}</td>
            <td class="col-xs-2">
              {{ course.is_archived ? 'Archived' : 'Active' }}
            </td>

            <td class="col-xs-1">
              <pl-menu :menuSize="3" direction="right">
                <pl-button slot="menu_trigger" class="pl-icon">
                  <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                </pl-button>
                <ul menu-content>
                  <li @click="archiveCourseFromTable(course)">
                    {{ course.is_archived ? 'Restore' : 'Archive' }} Course
                  </li>
                  <li
                    @click="deleteCourseFromTable(course)"
                    style="color: #e53935"
                  >
                    Delete Course
                  </li>
                </ul>
              </pl-menu>
            </td>
          </tr>
        </tbody>
        <div
          v-else-if="coursesList.length == 0"
          class="center-xs b no-users-style"
        >
          No Courses.
        </div>
        <div
          class="flex center-xs middle-xs h-inherit"
          v-if="loadingTable"
          key="loading"
        >
          <pl-spinner />
        </div>
      </table>
      <course-details-modal
        v-if="selected_course"
        @close="selected_course = null"
        :courseSelected="selected_course"
        :teachers="teachers"
      />
      <!-- Course Deletion -->
      <dialog-delete-confirm
        v-if="show_delete_course_modal"
        @close="show_delete_course_modal = false"
        @actionConfirmed="deleteCourses"
        :header="deleteHeader"
        :subHeader="deleteSubHeader"
        :labelText="deleteLabelText"
        :optionalText="optional_text"
      />
      <!-- Course Archive -->
      <dialog-delete-confirm
        v-if="show_archive_course_modal"
        @close="show_archive_course_modal = false"
        header="Are you sure want to archive this"
        submitButton="ARCHIVE"
        labelText='Please type in "confirm" to archive this item'
        subHeader="Archiving this course will stop students from being able to see or enter the course, and it will move this course to the bottom of the list on your dashboard. You can restore the course at any time."
        @actionConfirmed="archiveCourse"
        optionalText="Course"
      />
    </template>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';
  import adminServices from 'services/admin/adminServices';
  import dialogDeleteConfirm from 'components/dialogDeleteConfirm';
  import CourseDetailsModal from './courseDetailsModal.vue';

  export default {
    components: { dialogDeleteConfirm, CourseDetailsModal },
    watch: {},
    data() {
      return {
        allSelected: false,
        selectedCourses: [],
        to_delete_courses: [],
        to_archive_courses: [],
        show_delete_course_modal: false,
        show_archive_course_modal: false,
        delete_header: 'Are you sure you want to delete this',
        delete_sub_header:
          'This course and its contents cannot be restored after you take this action.',
        delete_label_text: 'Please type in "confirm" to delete this item',
        optional_text: '',
        roles: ['teacher', 'student'],
        loadingUser: '',
        schoolID: null,
        selected_course: null,
        selected_archive_course: null,
        loadingTable: false,
        totalSchoolCourses: 0,
      };
    },
    props: {
      coursesList: {
        type: Array,
        default() {
          return [];
        },
      },
      teachers: {
        type: Array,
        default() {
          return [];
        },
      },
      loading: {
        type: Boolean,
        required: true,
      },
      schoolCoursesCount: {
        type: Number,
        default: 0,
      },
    },
    computed: {
      ...mapGetters(['hasAdminAdminPermission', 'hasAdminCoachPermission']),
      deleteHeader() {
        return this.to_delete_courses.length > 1
          ? this.delete_header.replace('this', 'these')
          : this.delete_header;
      },
      deleteSubHeader() {
        return this.to_delete_courses.length > 1
          ? this.delete_sub_header
              .replace('This', 'These')
              .replace('course', 'courses')
          : this.delete_sub_header;
      },
      deleteLabelText() {
        return this.to_delete_courses.length > 1
          ? this.delete_label_text
              .replace('this', 'these')
              .replace('item', 'items')
          : this.delete_label_text;
      },
    },
    methods: {
      getTotalCoursesSchool() {
        adminServices
          .getTotalSchoolCoursesCount(this.schoolID)
          .then(({ data }) => (this.totalSchoolCourses = data));
      },
      openCourseDetails(course) {
        this.selected_course = course;
      },
      removeCourses() {
        this.optional_text = 'Courses';
        this.to_delete_courses = this.selectedCourses;
        this.show_delete_course_modal = true;
      },
      selectAll() {
        const all_s = this.allSelected;
        this.coursesList.forEach((itm) => (itm.selected = all_s));
        this.selectedCourses = this.coursesList.filter((itm) => itm.selected);
      },
      checkAllSelected() {
        this.allSelected = this.coursesList.every((itm) => itm.selected);
        this.selectedCourses = this.coursesList.filter((itm) => itm.selected);
      },
      archiveCourseFromTable(course) {
        this.selected_archive_course = course;
        if (!course.is_archived) this.show_archive_course_modal = true;
        else this.archiveCourse();
      },
      deleteCourseFromTable(course) {
        this.optional_text = 'Course';
        this.show_delete_course_modal = true;
        this.to_delete_courses = [course];
      },
      deleteCourses() {
        const courses_ids = this.to_delete_courses.map((c) => c.id);
        adminServices
          .deleteSchoolCourses(this.schoolID, courses_ids)
          .then(() => {
            EventBus.$emit('toast-msg', 'Success! Courses were deleted');
            this.$emit('updateNumberOfCourses', this.to_delete_courses);
            this.totalSchoolCourses -= this.to_delete_courses.length;
            this.to_delete_courses = [];
            this.selectedCourses = [];
          });
      },
      archiveCourse() {
        const courses_ids = [this.selected_archive_course.id];
        adminServices
          .archiveSchoolCourses(this.schoolID, courses_ids)
          .then(() => {
            EventBus.$emit('getSchoolCourses');
            this.selected_archive_course = null;
          });
      },
      cleanCoursesTableEvent() {
        EventBus.$on('admin-portal-filter-changed', () => {
          this.coursesList.map((itm) => {
            return (itm.selected = false);
          });
          this.allSelected = false;
          this.selectedCourses = [];
        });
      },
    },
    created() {},
    mounted() {
      const { schoolID } = this.$route.params;
      this.schoolID = schoolID;
      this.getTotalCoursesSchool();
    },
    beforeDestroy() {
      EventBus.$off('admin-portal-filter-changed');
    },
  };
</script>

<style lang="stylus" scoped>
  @import '~app/global-stylus.styl';

  .users-table
    padding 0
    tbody
      display:block
      overflow-y: auto
      height: calc(100vh - 310px)
      padding: 10px 8px
      tr
        border: 2px solid #e6e7e7
        border-bottom: none;
        align-items: center
        &:last-child
          border-bottom: 2px solid #e6e7e7
    td
      padding 1rem
      &.pending
        color: pl-ruby
      &.name-cell
        color: #78BEC8
        text-decoration: underline
      &.email-cell
        overflow: hidden
        text-overflow: ellipsis
        white-space: nowrap
    thead tr
      padding: 0 10px;
      td
        padding: 0 1rem

  .no-users-style
    padding-top: 20px;

  .remove-selected-users{
    margin: 6px 0px;
  }
  .ruby
    color:pl-ruby

  .name-cell
    color: #78BEC8
    text-decoration: underline

  .avatar-size
    width: 40px
    height: 40px
</style>



// WEBPACK FOOTER //
// coursesTable.vue?1d4bbce6